<template>
  <ul class="InfoListCom">
    <li
      class="courseLi"
      v-for="v in list"
      :key="v.id"
      @mouseenter="enter(v.id)"
    >
      <div class="imgBox" v-if="$route.path == '/projectInformation'">
        <el-image
          style="width: 100%; height: 100%"
          :src="v.imgUrl"
          fit="fill"
        ></el-image>
      </div>
      <p class="timeBox" v-if="$route.path == '/historicalMonument'">
        {{ v.time }}
      </p>

      <div
        :class="{
          txtBox: true,
          betweenRow: $route.path == '/projectInformation',
        }"
      >
        <div class="titleBox">
          <h5 v-if="$route.path == '/historicalMonument'">{{ v.title }}</h5>
          <h5
            class="limitationRow"
            @click="showDetails(v)"
            v-if="$route.path == '/projectInformation'"
          >
            {{ v.title }}
          </h5>
          <span v-if="hoverId == v.id && authority">
            <el-button
              icon="el-icon-edit"
              size="mini"
              circle
              @click="clickEdit(v)"
            ></el-button>
            <el-button
              icon="el-icon-delete"
              size="mini"
              circle
              @click="deleteItem(v.id)"
            ></el-button>
          </span>
        </div>
        <p :class="{ limitationP: $route.path == '/projectInformation' }">
          {{ v.content }}
        </p>
        <span v-if="$route.path == '/projectInformation'"
          >更新时间:{{ v.time }}</span
        >
      </div>
    </li>
    <el-drawer
      :visible.sync="drawerState"
      v-if="infoDetails"
      title="详情"
      class="drawerWrap"
      size="40%"
      :before-close="handleClose"
    >
      <InfoDetails :clickItem="clickItem" />
    </el-drawer>
  </ul>
</template>

<script>
import api from "@/api";
import InfoDetails from "@/components/xiangmuxinxi/InfoDetails";
export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    authority: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    InfoDetails,
  },
  data() {
    return {
      hoverId: null,
      infoDetails: false,
      drawerState: false,
    };
  },
  methods: {
    enter(id) {
      this.hoverId = id;
    },
    deleteItem(id) {
      this.$confirm(`确定删除信息?`, "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        callback: (action) => {
          if (action === "confirm") {
            this.$store.commit("SET_LOADING", true);
            return new Promise(async (resolve) => {
              let res = await api.projectInfoDelete({}, id);
              if (res && res.data.code == 200) {
                this.$message.success("删除成功!");
                setTimeout(() => {
                  this.$store.commit("SET_LOADING", false);
                  this.$parent.getListData();
                }, 500);
              }
              resolve();
            });
          }
        },
      });
    },
    showDetails(item) {
      this.clickItem = item;
      this.infoDetails = true;
      this.$nextTick(() => {
        this.drawerState = true;
      });
    },
    handleClose() {
      this.infoDetails = false;
      this.drawerState = false;
    },
    clickEdit(data) {
      this.$emit("getClickEdit", data);
    },
  },
};
</script>

<style lang="scss" scoped>
.InfoListCom {
  width: 80%;
  margin: 0 auto;
  padding: 20px 0 16px;
  .courseLi {
    width: 100%;
    margin-bottom: 25px;
    padding-bottom: 25px;
    border-bottom: 1px dotted #e5e5e5;
    @include setFlexStart;
    align-items: flex-start;
    .timeBox {
      display: inline-block;
      padding: 5px 15px;
      color: #fff;
      border-radius: 20px;
      font-size: 15px;
    }
    .imgBox {
      width: 15%;
      height: 130px;
    }
    .txtBox {
      width: 88%;
      height: 100%;
      margin-left: 20px;
      .titleBox {
        width: 100%;
        margin-bottom: 10px;
        @include setFlexBetween;
        h5 {
          padding: 5px 0;
          font-size: 18px;
          width: 90%;
        }
        .limitationRow {
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-break: break-all;
          &:hover {
            color: $themeColor;
            cursor: pointer;
          }
        }
      }
      .limitationP {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .betweenRow {
      height: 130px;
      @include setFlexColumn;
      justify-content: space-between;
    }
  }
  .courseLi:nth-child(3n + 1) {
    .timeBox {
      background: #f1ab45;
    }
  }
  .courseLi:nth-child(3n + 2) {
    .timeBox {
      background: #3579ff;
    }
  }
  .courseLi:nth-child(3n + 3) {
    .timeBox {
      background: #1ec9b1;
    }
  }
}
</style>
